import React, { Component } from 'react';
import styled from 'styled-components';

import COLORS from 'constants/colors';
import { HEADER_ICONS } from 'constants/chapter-block';
import { BLOCK_TYPE_OPTIONS } from 'constants/block-options';
import { Text, Row, FlexView, Col } from '@cuemath/comps';

import SheetItem from './sheet-item';

const TitleRow = styled(Row)`
  padding-left: ${({ isGoal }) => (isGoal ? '24px' : '0')};
`;

const TitleImage = styled.img`
  width: 24px;
  height: 24px;
`;

const BlockWrapper = styled(FlexView)`
  width: 780px;
  border-radius: 4px;
  background-color: ${COLORS.WHITE};
  box-shadow: 0 5px 15px 0 rgba(51, 79, 110, 0.1);
  border: 1px solid rgba(34, 36, 38, 0.15);
  transition: all 0.2s ease-in-out;
`;

const BlockHeader = styled(Row)`
  position: relative;
  cursor: ${({ haveSheets }) => (haveSheets ? 'pointer' : 'default')};
  padding-left: 12px;
  padding-right: 12px;
`;

const BlockBody = styled(FlexView)`
  height: ${({ isClosed }) => (isClosed ? 0 : '100%')};
  transition: height 10s ease-in-out;
  position: relative;
  padding: ${({ isClosed }) => (isClosed ? '0' : '0 0 50px')};
`;

const FullTextContainer = styled.div`
  position: relative;
`;

const FullText = styled(Text)`
  background-color: ${COLORS.WHITE};
  box-shadow: 2px 2px 5px 2px rgba(0, 56, 122, 0.15);
  position: absolute;
  top: -12px;
  left: 0;
  right: 0;
  padding: 6px 12px;
  width: fit-content;
  top: calc(-100% - 12px);
  border-radius: 4px;
  display: none;
  z-index: 1;
  opacity: 0;
  transition: display 1s, opacity 1s ease-in-out;

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    top: calc(-100% - 35px);
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    top: calc(-100% - 35px);
  }

  ${FullTextContainer}:hover & {
    display: block;
    opacity: 1;
  }
`;

const BlockText = styled(Text)`
  max-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const GradeTextContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 48px;
  height: 48px;
  background-color: ${COLORS.SKY_DARK};
  border-top-left-radius: 4px;
  border-bottom-right-radius: 100%;
  opacity: ${({ isClosed }) => (isClosed ? 0.5 : 1)};
`;

const GradeText = styled(Text)`
  padding-left: 6px;
  padding-top: 6px;
`;

const VerticalLine = styled.div`
  width: 2px;
  height: ${({ height = 18 }) => `${height}px`};
  background-color: ${COLORS.HEART_LIGHT};
`;

class ChapterBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isClosed: true,
      blockData: {},
      blockModalOpen: false,
    };
  }

  toggleChapters = () => {
    const { isClosed } = this.state;

    this.setState({
      isClosed: !isClosed,
    });
  };

  render() {
    const headerIcon = HEADER_ICONS.DEFAULT;
    const { isClosed } = this.state;
    const {
      sheets,
      description,
      goalIndex,
      blockType,
      isLastBlock,
      dependencyDataList,
      nodeDataList,
      linkedDataList,
    } = this.props;

    return (
      <FlexView>
        <BlockWrapper>
          <BlockHeader
            justifyContent="space-between"
            haveSheets={sheets && sheets.length > 0}
            gap
            gutter
            onClick={sheets && sheets.length > 0 ? this.toggleChapters : null}
          >
            {blockType === BLOCK_TYPE_OPTIONS.GOAL && (
              <GradeTextContainer isClosed={isClosed}>
                <GradeText
                  size="larger"
                  weight="bold"
                  color={COLORS.WHITE}
                >{`G${goalIndex}`}</GradeText>
              </GradeTextContainer>
            )}
            <TitleRow alignItems="center" isGoal={blockType === BLOCK_TYPE_OPTIONS.GOAL}>
              {blockType !== BLOCK_TYPE_OPTIONS.GOAL && (
                <TitleImage src={headerIcon} alt="basic" />
              )}
              <Col>
                <FullTextContainer>
                  <FullText size="small" weight="semibold">
                    {description || ''}
                  </FullText>
                  <BlockText
                    size="large"
                    weight="bold"
                    color={isClosed ? COLORS.COLA : COLORS.PRIMARY}
                  >
                    {description || ''}
                  </BlockText>
                </FullTextContainer>
              </Col>
            </TitleRow>
          </BlockHeader>

          {sheets && sheets.length > 0 && (
            <BlockBody isClosed={isClosed}>
              {!isClosed && (
                <>
                  {sheets
                    .sort((a, b) => a.position - b.position)
                    .map((item, index) => {
                      return (
                        <SheetItem
                          key={item.id}
                          {...item}
                          nodeDataList={nodeDataList}
                          nodeId={item.id}
                          dependencyDataList={dependencyDataList[item.id]}
                          linkedDataList={linkedDataList[item.id]}
                          isLastSheet={index === sheets.length - 1}
                        />
                      );
                    })}
                </>
              )}
            </BlockBody>
          )}
        </BlockWrapper>
        {!isLastBlock && (
          <Row>
            <Col gutter={24}>
              <VerticalLine />
            </Col>
          </Row>
        )}
      </FlexView>
    );
  }
}

export default ChapterBlock;
